import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'

export const clearNotifications = createAction('ntf/CLEAR_NOTIFICATIONS')
export const getNotifications = createAction('ntf/GET_NOTIFICATIONS')
export const getNotificationsSuccessful = createAction(
  'ntf/GET_NOTIFICATIONS_SUCCESSFUL'
)
export const getNotificationsFailure = createAction(
  'ntf/GET_NOTIFICATIONS_FAILURE'
)

export const viewNotification = createPromiseAction('rspa: VIEW_NOTIFICATION')()
